import React from 'react';
import { Grid, ProductTile, FrameBone, ParagraphBone } from '@gik/ui';
import bemBlock from '@gik/core/utils/bemBlock';
import { useProducts } from '@gik/checkout';
import withSuspense from '@gik/core/components/suspended/withSuspense';
import ProductTileToolbar from '@gik/ui/gik/ProductTile/ProductTileToolbar';

export interface IProductsGridProps extends React.HTMLAttributes<HTMLDivElement> {
  inkindRouteId?: string;
  userId?: string;
  skeleton: boolean;
  skeletonItems: number;
}

const Skeleton = ({ skeletonItems = 4 }: Partial<IProductsGridProps>): React.ReactElement => {
  const skelBem = bemBlock(`products-grid-skeleton`);
  return (
    <Grid cols={3} className={skelBem()}>
      {Array.from(Array(skeletonItems).keys()).map(index => {
        return (
          <div key={index} className={skelBem('item')}>
            <FrameBone className={skelBem('image')} />
            <main>
              <ParagraphBone words={10} className={skelBem('text')} />
            </main>
          </div>
        );
      })}
    </Grid>
  );
};

function ProductsGrid({ className, inkindRouteId }: IProductsGridProps): JSX.Element {
  const bem = bemBlock('products-grid');
  const { data: products, error: productsError } = useProducts([]);

  const isLoading = !products;
  const isError = isLoading && productsError;

  if (isLoading) return <Skeleton />;
  if (isError) return <Skeleton />;

  return (
    <Grid cols={3} className={bem(null, null, className)}>
      {products?.map(product => {
        return (
          <ProductTile
            key={product.id}
            imageUrl={product.thumbnails && product.thumbnails[0]}
            toolbar={<ProductTileToolbar itemId={product.id} inkindRouteId={inkindRouteId} />}
            title={product.name}
          />
        );
      })}
    </Grid>
  );
}

export default withSuspense(ProductsGrid, Skeleton);
